"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchDetailsModal = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Row_1 = require("@amzn/atoz-web/Row");
const Button_1 = require("@amzn/atoz-web/Button");
const Text_1 = require("@amzn/atoz-web/Text");
const Icons_1 = require("@amzn/atoz-web/Icons");
const Modal_1 = require("@amzn/atoz-web/Modal");
const View_1 = require("@amzn/atoz-web/View");
const Modal_2 = require("@amzn/atoz-web/Modal");
const Theme_1 = require("@amzn/atoz-web/Theme");
const MessageBanner_1 = require("@amzn/atoz-web/MessageBanner");
const logger_1 = require("../../logger");
const PunchDetailsSection_web_1 = require("./PunchDetailsSection.web");
const PunchDetailsModal = ({ title, timestampString, punchDetails, punchDateTime, closeModal, isInProgress, isInPending, isPunchEditable, isPunchDeletable, renderPunchDeletionConfirmationModal, renderPunchEditModal, isDeleteAIPPunch }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [isPunchEditModalOpen, setIsPunchEditModalOpen] = react_1.default.useState(false);
    const [isPunchDeleteModalOpen, setIsPunchDeleteModalOpen] = react_1.default.useState(false);
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.PUNCH_DETAILS.COUNT
        },
        isComponentLoaded: true
    });
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.PUNCH_EDIT_BUTTON.COUNT
        },
        isComponentLoaded: isPunchEditable && renderPunchEditModal
    });
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.PUNCH_DELETE_BUTTON.COUNT
        },
        isComponentLoaded: isPunchDeletable && renderPunchDeletionConfirmationModal
    });
    const renderPunchEdit = () => {
        return (renderPunchEditModal && (react_1.default.createElement(Modal_2.Modal, { isOpen: isPunchEditModalOpen, close: closeModal }, renderPunchEditModal({
            close: closeModal
        }))));
    };
    const renderPunchDelete = () => {
        return (renderPunchDeletionConfirmationModal && (react_1.default.createElement(Modal_2.Modal, { isOpen: isPunchDeleteModalOpen, close: closeModal }, renderPunchDeletionConfirmationModal({
            close: closeModal
        }, punchDateTime, isDeleteAIPPunch))));
    };
    const renderButtons = () => {
        const editBtn = (react_1.default.createElement(Button_1.Button, { onClick: () => {
                setIsPunchEditModalOpen(isPunchEditable);
            }, style: { width: '100%' }, key: "PunchDetailsModalEditButton", variant: Button_1.ButtonVariant.Primary, dataTestId: "PunchDetailsModalEditButton", "aria-label": t('time_and_attendance_PunchDetailsModal_Edit') }, t('time_and_attendance_PunchDetailsModal_Edit')));
        const deleteBtn = (react_1.default.createElement(Button_1.Button, { onClick: () => {
                setIsPunchDeleteModalOpen(isPunchDeletable);
            }, style: { width: '100%' }, isDestructive: true, key: "PunchDetailsModalDeleteButton", variant: Button_1.ButtonVariant.Secondary, dataTestId: "PunchDetailsModalDeleteButton", "aria-label": t('time_and_attendance_PunchDetailsModal_Delete') }, t('time_and_attendance_PunchDetailsModal_Delete')));
        const buttons = [];
        if (isPunchDeletable && renderPunchDeletionConfirmationModal) {
            buttons.push(deleteBtn);
        }
        if (isPunchEditable && renderPunchEditModal) {
            buttons.push(editBtn);
        }
        return buttons;
    };
    const renderInProgressContent = () => (react_1.default.createElement(View_1.View, { margin: { top: 'S500' } },
        react_1.default.createElement(IconTitleWrapper, null,
            react_1.default.createElement(IconWrapper, null,
                react_1.default.createElement(Icons_1.IconRefresh, { color: "neutral70", size: Icons_1.IconSize.Large, dataTestId: "icon-refresh", title: t('time_and_attendance_icon_punch_in_progress') })),
            react_1.default.createElement(Text_1.H1, { fontWeight: 500, fontSize: "T400", margin: { top: 'S400' } }, t('time_and_attendance_in_progress'))),
        react_1.default.createElement(Text_1.Text, { fontSize: "T300", color: "neutral80", textAlign: "center" }, isInPending
            ? t('time_and_attendance_PunchToastModal_Punch_In_Progress_Text')
            : t('time_and_attendance_PunchToastModal_PunchEdit_In_Progress_Text')),
        react_1.default.createElement(Text_1.Text, { fontSize: "T100", color: "neutral80", margin: { top: 'S400' } }, t('time_and_attendance_PunchToastModal_PunchEdit_Note_Text'))));
    const renderNoActionBanner = () => (react_1.default.createElement(Row_1.Row, { margin: { top: 'S400' } },
        react_1.default.createElement(MessageBanner_1.MessageBanner, { dataTestId: "PunchDetailsModalNoActionBanner", iconAltText: t('time_and_attendance_Warning'), type: MessageBanner_1.MessageBannerType.Informational }, t('time_and_attendance_PunchDetailsModal_NoAction'))));
    const renderPunchDetailContent = () => (react_1.default.createElement(View_1.View, { margin: { top: 'S500' } },
        react_1.default.createElement(IconTitleWrapper, null,
            react_1.default.createElement(IconWrapper, null,
                react_1.default.createElement(Icons_1.IconClockFill, { color: "primary70", size: Icons_1.IconSize.Large, dataTestId: "icon-clock-fill", title: t('time_and_attendance_icon_punch_time') })),
            react_1.default.createElement(Text_1.H1, { fontWeight: 500, fontSize: "T400", margin: { top: 'S400' } }, title),
            react_1.default.createElement(TimeStampText, null, timestampString)),
        !!punchDetails && react_1.default.createElement(PunchDetailsSection_web_1.PunchDetailsSection, { punchDetails: punchDetails }),
        isPunchDeletable && renderPunchDelete(),
        isPunchEditable && renderPunchEdit(),
        !isPunchDeletable && !isPunchEditable && renderNoActionBanner()));
    return (react_1.default.createElement(Modal_1.ModalContent, { dataTestId: "PunchDetailsModal", onCloseButtonClick: closeModal, titleText: "", buttons: renderButtons(), closeButtonAltText: t('time_and_attendance_Close') }, isInProgress ? renderInProgressContent() : renderPunchDetailContent()));
};
exports.PunchDetailsModal = PunchDetailsModal;
const IconTitleWrapper = (0, Theme_1.styledWithTheme)(View_1.View)(({ theme }) => `
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.selectors.space('S200')}px;
  `);
const IconWrapper = (0, Theme_1.styledWithTheme)(View_1.View)(`
    padding: 16px 0;
    svg {
      scale: 2
    }
  `);
const TimeStampText = (0, Theme_1.styledWithTheme)(Text_1.Text)(({ theme }) => `
    color:  ${theme.selectors.color('neutral80')};
    fontSize: ${theme.selectors.fontSize('T300')} `);
